import React from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectUser } from "../../store/slice/user";
import { Style } from "./style";

const SiteFooter = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { language } = useSelector(selectUser);
  const isArabic = language === "ar";

  const links = [
    { label: t("marketing.nav.home"), path: "/" },
    { label: t("marketing.nav.howItWorks"), path: "/how-it-works" },
    { label: t("marketing.nav.pricing"), path: "/pricing" },
    { label: t("marketing.nav.about"), path: "/about" },
    { label: t("marketing.nav.contactSales"), path: "/contact-sales" },
  ];

  return (
    <Box component="footer" sx={Style.footer}>
      <Box sx={Style.links(isArabic)}>
        {links.map((l) => (
          <Box key={l.path} component="span" sx={Style.link(isArabic)} onClick={() => navigate(l.path)}>
            {l.label}
          </Box>
        ))}
      </Box>
      {t("marketing.footer.copyright")}
    </Box>
  );
};

export default SiteFooter;
